import { render, staticRenderFns } from "./editable-car-brand-field.vue?vue&type=template&id=32e803bc&scoped=true"
import script from "./editable-car-brand-field.vue?vue&type=script&lang=js"
export * from "./editable-car-brand-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e803bc",
  null
  
)

export default component.exports